// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sticker__sticker-d15c25 {
  display: inline-block;
}

button.Sticker__sticker-d15c25 {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Sticker/Sticker.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".sticker {\n  display: inline-block;\n}\n\nbutton.sticker {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": `Sticker__sticker-d15c25`
};
module.exports = ___CSS_LOADER_EXPORT___;
